import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'text'})
export class TextPipe implements PipeTransform {
  transform(value:string, args:string[]) : any {
    if(value === undefined) {
      return '';
    }
    if(args[0] === 'cap_first'){
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    else if(args[0] === 'trim_order_id'){
      return value.substring(3, value.length);
    }
    if(args[0] === 'currency'){
      return '$' + parseFloat(value).toFixed(2).toString();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/pipes/text.ts